import { useState } from 'preact/hooks';
import { useAsyncEffect } from 'client/utils/use-async-effect';

export function CreatingPageAnimation() {
  const [progress, setProgress] = useState(0);

  useAsyncEffect(async () => {
    // Animate progress while LLM generates landing page content (~30 seconds)
    const totalDuration = 30000;
    const iterations = 100;
    const stepDuration = totalDuration / iterations;
    for (let i = 0; i <= iterations; i += 1) {
      setProgress(i);
      await new Promise((r) => setTimeout(r, stepDuration));
    }
  }, []);

  return (
    <div class="fixed inset-0 z-50 flex h-screen items-center justify-center bg-gradient-to-tr from-gray-100 to-indigo-100">
      <div class="text-center">
        <h2 class="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
          Creating Your Landing Page
        </h2>
        <p class="mt-4 text-lg text-gray-600 mb-16">
          Please wait while we set up your personalized landing page.
        </p>
        <div class="w-lg mx-auto">
          <div class="relative">
            <div class="flex justify-between items-center mb-3">
              <span class="text-sm font-medium text-gray-700">Progress</span>
              <span class="text-sm font-semibold text-indigo-600">{progress}%</span>
            </div>
            <div class="relative h-4 bg-gray-200 rounded-full overflow-hidden shadow-inner">
              <div
                class="absolute inset-y-0 left-0 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full transition-all duration-300 ease-out shadow-lg"
                style={{
                  width: `${progress}%`,
                }}
              ></div>
            </div>
            <div class="flex justify-between mt-2">
              <span class="text-xs text-gray-500">Getting started...</span>
              <span class="text-xs text-gray-500">Almost there!</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
